// Angle math. Angles are stored/transported in radians everywhere (graph ports,
// scene transforms, the WASM engine); only UI presentation converts to degrees.
// Use these helpers instead of inlining the conversion factors.

export const TWO_PI = Math.PI * 2;
export const DEG2RAD = Math.PI / 180;
export const RAD2DEG = 180 / Math.PI;

export function degToRad(deg: number): number {
  return deg * DEG2RAD;
}

export function radToDeg(rad: number): number {
  return rad * RAD2DEG;
}
